import Vue from 'vue';
import "babel-polyfill";
import Vuex from 'vuex';
import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'
Vue.use(Vuex);
const state = { //要设置的全局访问的state对象
  token: null,
  user_info: {},
  isLogin: false,
  suitid:101,
  messages_count:0,
  defaultActiveUrl:""
};
const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js